var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorizontal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.25C22.5 9.51562 21.4688 10.5 20.25 10.5H6.75C5.48438 10.5 4.5 9.51562 4.5 8.25V6.75C4.5 5.53125 5.48438 4.5 6.75 4.5H20.25C21.4688 4.5 22.5 5.53125 22.5 6.75V8.25ZM16.5 23.25C16.5 24.5156 15.4688 25.5 14.25 25.5H6.75C5.48438 25.5 4.5 24.5156 4.5 23.25V21.75C4.5 20.5312 5.48438 19.5 6.75 19.5H14.25C15.4688 19.5 16.5 20.5312 16.5 21.75V23.25Z",
    fill: "#465DD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M6.75 18C5.48438 18 4.5 17.0156 4.5 15.75V14.25C4.5 13.0312 5.48438 12 6.75 12H23.25C24.4688 12 25.5 13.0312 25.5 14.25V15.75C25.5 17.0156 24.4688 18 23.25 18H6.75Z",
    fill: "#465DD8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontal);
export default __webpack_public_path__ + "static/media/horizontal.89c4cd7b.svg";
export { ForwardRef as ReactComponent };